module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/bottom_bg-aee0dac522675dcf46a856148022b5f4.svg";